import {Component, computed, input, output} from '@angular/core';
import {OptionsSelectComponent} from '../../../inputs/options-select/options-select.component';
import {SelectOption, SelectValue} from '../../../inputs/options-select/options-select.types';
import {FULFILLMENT_VALUES, NUMERIC_VALUES} from './attribute-fulfillment-ternary.types';

@Component({
  selector: 'app-attribute-fulfillment-ternary',
  imports: [OptionsSelectComponent],
  templateUrl: './attribute-fulfillment-ternary.component.html',
})
export class AttributeFulfillmentTernaryComponent {
  readonly score = input.required<number | null>();
  readonly disabled = input.required<boolean>();
  readonly testIdKey = input.required<string>();

  readonly valueChange = output<number>();

  readonly displayValue = computed<SelectValue>(() => {
    const score = this.score();
    if (score == undefined) {
      return undefined;
    }
    if (score === NUMERIC_VALUES.FULL) return FULFILLMENT_VALUES.FULL;
    if (score === NUMERIC_VALUES.PARTLY) return FULFILLMENT_VALUES.PARTLY;
    return FULFILLMENT_VALUES.NONE;
  });

  readonly options = computed<SelectOption[]>(() => [
    {directusKey: 'provider.tenderResponse.fulfillmentScore.full', value: FULFILLMENT_VALUES.FULL},
    {
      directusKey: 'provider.tenderResponse.fulfillmentScore.partly',
      value: FULFILLMENT_VALUES.PARTLY,
    },
    {directusKey: 'provider.tenderResponse.fulfillmentScore.none', value: FULFILLMENT_VALUES.NONE},
  ]);

  onValueChange(value: SelectValue): void {
    if (value === FULFILLMENT_VALUES.PARTLY) {
      this.valueChange.emit(NUMERIC_VALUES.PARTLY);
      return;
    }
    if (value === FULFILLMENT_VALUES.FULL) {
      this.valueChange.emit(NUMERIC_VALUES.FULL);
      return;
    }
    this.valueChange.emit(NUMERIC_VALUES.NONE);
  }
}
